"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capital = void 0;
function capital(source) {
    var numbStr = String(source);
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(numbStr))
        return '';
    var unit = '千百拾亿千百拾万千百拾元角分';
    var str = '';
    numbStr += '00';
    var p = numbStr.indexOf('.');
    if (p >= 0)
        numbStr = numbStr.substring(0, p) + numbStr.substr(p + 1, 2);
    unit = unit.substr(unit.length - numbStr.length);
    for (var i = 0; i < numbStr.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(Number(numbStr.charAt(i))) + unit.charAt(i);
    }
    return str
        .replace(/零(千|百|拾|角)/g, '零')
        .replace(/(零)+/g, '零')
        .replace(/零(万|亿|元)/g, '$1')
        .replace(/(亿)万|壹(拾)/g, '$1$2')
        .replace(/^元零?|零分/g, '')
        .replace(/元$/g, '元整');
}
exports.capital = capital;
